import React, { useContext, useEffect, useState } from "react";
import GettingStartedContext from "../utils/GettingStartedContext";
import VideoBg from "reactjs-videobg";
import Logo from "../containers/logo";
import ContentForm from "../containers/question-details";
import SkipButton from "../containers/skip-button";
import QNumbers from "../containers/question-numbers";
import HelpSidebar from "../containers/help-sidebar";
import HelpButton from "../containers/help-button";
import StartOverButton from "../containers/start-over-button";
import ResultSummarySection from "../containers/result-summary-section";
import SkipHeroSection from "../containers/skip-page-hero";
import ExcerptSection from "./result-excerpt-section";
import PricingCostSection from "./pricingCostSection";
import FormSection from "../containers/contact-form-section";
import TestimonialsSection from "../containers/result-testimonial-section";
import DownloadPopup from "../containers/download-popup";
import DetailSection from "./result-detail-section";
import Dropdown from "../containers/dropdown-field";
import LocationInput from "../containers/location-input";

const App = ({ widgetKey }) => {
    const [loaded, setLoaded] = useState(false);
    const [jsonResponse, setJsonResponse] = useState(null);

    const {
        data,
        link,
        lang,
        activeHours,
        reloadResults,
        setReloadResults,
        showResult,
        setShowResult,
        showSkip,
        setShowSkip,
        question,
        setQuestion,
        setData,
        result,
        setResult,
        plane,
        setPlane,
        ownership,
        setOwnership,
        plan,
        setPlan,
        hours,
        setHours,
        location,
        setLocation,
        showDownloadPricing,
        requestVariable,
        getProperty,
        showFooter,
        langString,
        showToolTip,
        staticBlock,
        setStaticBlock,
    } = useContext(GettingStartedContext);

    const [init, setInit] = useState(false);
    const [loading, setLoading] = useState(true);
    const [testimonials, setTestimonials] = useState([]);

    useEffect(() => {
        loadContents();
    }, []);

    useEffect(() => {
        if (plane && ownership && !showSkip) {
            loadResults();
        } else if (requestVariable("aircraft")) {
            loadResults();
        }
    }, [reloadResults]);

    const loadContents = () => {
        fetch(`${link}/getAllContent`)
            .then((response) => response.json())
            .then((json) => {
                setData(json);
                const activePlane = requestVariable("aircraft");
                const activeOwnership = requestVariable("ownership");
                if (activePlane && activeOwnership) {
                    // setOwnership(activeOwnership);
                    // setPlane(activePlane);
                    setPlan(requestVariable("plan"));
                    setPlane(activePlane);
                    setOwnership(activeOwnership);
                    setReloadResults(!reloadResults);
                } else {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        if (data !== null) {
            displayResults();
        }
    }, [jsonResponse]);

    const displayResults = () => {
        if (data && jsonResponse) {
            if (!jsonResponse.BestPlane) {
                jsonResponse.BestPlane = jsonResponse.Plane;
            }
            if (!jsonResponse.BestOwnership) {
                jsonResponse.BestOwnership = jsonResponse.Ownership;
            }

            const options = {
                ...data.Options,
                ...jsonResponse,
            };

            setData({
                ...data,
                Options: options,
            });

            const selectedPlan = hours
                ? jsonResponse.RelatedPlans.find((ele) => ele.ID == hours)
                    ? jsonResponse.RelatedPlans.find((ele) => ele.ID == hours)
                    : jsonResponse.Plan
                : jsonResponse.Plan;

            setPlan(selectedPlan);
            // setPlane(jsonResponse.Plane);
            // setOwnership(jsonResponse.Ownership);
            setHours(selectedPlan ? selectedPlan.ID : 0);
            setShowResult(true);
            setLoading(false);
            setInit(true);
        }
    };

    const loadResults = () => {
        const selectedOwnerShip = document.querySelector(
            'select[name="ownerships"]'
        );

        if (requestVariable("plan") && !init) {
            fetch(`${link}/getManualResults`, {
                method: "POST",
                body: JSON.stringify({
                    data: {
                        plane: requestVariable("aircraft"),
                        ownership: requestVariable("ownership"),
                        plan: requestVariable("plan"),
                        hours: requestVariable("hours"),
                        location: null,
                    },
                }),
            })
                .then((response) => response.json())
                .then((json) => {
                    setJsonResponse(json);
                });
        } else {
            fetch(`${link}/getManualResults`, {
                method: "POST",
                body: JSON.stringify({
                    data: {
                        plane: plane ? plane : requestVariable("aircraft"),
                        ownership:
                            ownership || selectedOwnerShip
                                ? selectedOwnerShip
                                    ? selectedOwnerShip.value
                                    : ownership
                                : requestVariable("ownership"),
                        plan: plan ? plan.ID : null,
                        hours: hours ? hours : requestVariable("hours"),
                        location: location ? location : null,
                    },
                }),
            })
                .then((response) => response.json())
                .then((json) => {
                    setJsonResponse(json);
                });
        }
    };

    const getBackgroundImage = () => {
        return question ? question.ImageURL : data.ImageURL;
    };

    const getBackgroundVideo = () => {
        if (data.Video) return question ? question.Video : data.Video;
        else return "";
    };

    let resultsClass = "gsa gsa__results";
    if (showSkip) {
        resultsClass = "gsa gsa__results-skipped";
    }

    return (
        <>
            {!!loading && (
                <div className="gsa">
                    <div className="gsa__content">
                        <div className="gsa__loading">
                            <div className="grid-container">
                                <div>Loading...</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {data && !showResult && !showSkip && (
                <>
                    <div className="gsa">
                        <div
                            className="gsa__bg"
                            style={{
                                backgroundImage:
                                    "url(" + getBackgroundImage() + ")",
                            }}
                        >
                            {getBackgroundVideo().Link &&
                            getBackgroundVideo().Type !== "wistia" ? (
                                <VideoBg
                                    loop={true}
                                    autoPlay={true}
                                    muted={true}
                                >
                                    <VideoBg.Source
                                        src={getBackgroundVideo().Link}
                                        type={
                                            "video/" + getBackgroundVideo().Type
                                        }
                                    />
                                </VideoBg>
                            ) : (
                                ""
                            )}
                            {getBackgroundVideo().Link &&
                            getBackgroundVideo().Type === "wistia" ? (
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: getBackgroundVideo().Link,
                                    }}
                                />
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="gsa__content">
                            <div className="gsa__header">
                                <div className="grid-x">
                                    <div className="cell col-6">
                                        <Logo
                                            url={data.BaseURL}
                                            locale={lang}
                                        />
                                    </div>
                                    {/* {question && <> */}
                                    <div className="cell col-6 gsa__header-buttons">
                                        <ul>
                                            <HelpButton />
                                            <StartOverButton
                                                text={data.ExitText}
                                                startOver={false}
                                                exit={true}
                                            />
                                        </ul>
                                    </div>
                                    {/* </>} */}
                                </div>
                            </div>
                            <div className="gsa__form">
                                <ContentForm />
                            </div>
                            <SkipButton />
                            {!!question && <QNumbers />}
                            <HelpSidebar />
                        </div>
                    </div>
                </>
            )}

            {!loading && data && (showResult || showSkip) && (
                <>
                    <div className={resultsClass}>
                        {!!showResult && <ResultSummarySection />}
                        {!!showSkip && <SkipHeroSection />}
                        <ExcerptSection />
                        {/* <DetailSection /> */}
                        {!!showResult && <DetailSection />}
                        {!!showResult && (
                            <PricingCostSection widgetKey={widgetKey} />
                        )}
                        {!!showResult && <FormSection />}
                        {!!showResult && <TestimonialsSection />}
                        <HelpSidebar />
                        {!!showDownloadPricing && <DownloadPopup />}
                    </div>
                </>
            )}
        </>
    );
};

export default App;
